import {
  Avatar,
  Division,
  EmptyState,
  Flex,
  Heading,
  Icons,
  Paragraph,
} from "@ir/ui";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";
import type { BrandPurchaser } from "@src/domain/entities/brand";
import { BrandPurchaserStatusUpdate } from "./BrandPurchaserStatusUpdate";

interface BrandDetailsPurchasersContentProps {
  brandId: number;
  brandPurchasers: BrandPurchaser[] | null;
  onPurchaserStatusUpdated?: (purchaser: BrandPurchaser) => void;
}

export const BrandDetailsPurchasersContent = ({
  brandId,
  brandPurchasers,
  onPurchaserStatusUpdated,
}: BrandDetailsPurchasersContentProps) => {
  return (
    <ErrorBoundary>
      {brandPurchasers && brandPurchasers.length > 0 ? (
        brandPurchasers.map((purchaser) => (
          <Flex
            key={purchaser.purchaserId}
            align="center"
            className="py-2 mb-1"
          >
            <Avatar size="small" name={purchaser.purchaserName} />
            <Division style={{ marginLeft: "1rem", flex: 1 }}>
              <Paragraph
                className="text-grey-700 font-bold m-0"
                style={{ lineHeight: "1" }}
              >
                {purchaser.purchaserName}
              </Paragraph>
              <Paragraph
                className="m-0 p-0 text-grey-500 font-regular text-sm"
                style={{ fontSize: "0.65rem" }}
              >
                {purchaser.purchaserKey}
              </Paragraph>
            </Division>
            <Division>
              <BrandPurchaserStatusUpdate
                brandId={brandId}
                purchaserId={purchaser.purchaserId}
                brandPurchaserIsActive={purchaser.brandPurchaser.isActive}
                rowPurchaser={purchaser}
                onPurchaserStatusUpdated={onPurchaserStatusUpdated}
              />
            </Division>
          </Flex>
        ))
      ) : (
        <EmptyState
          className="bg-white border-1 border-color-grey-25 px-4 py-5 m-4"
          icon={Icons.InfoOctagon}
          title={
            <Heading level={6} className="text-grey-700 font-bold mt-3">
              No purchaser assigned to this brand.
            </Heading>
          }
        />
      )}
    </ErrorBoundary>
  );
};
